import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeCurlyBraceAnnotationLeft extends Shape {
    width = 200;
    height = 182;
    needFill = false;
    fillStyleEnabled = false;
    borderStyleEnabled = false;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width * 0.75 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 4 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 50;

        const horizontalLineW = w * 0.2;
        const horizontalLineH = h * 0.38;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.beginPath();

        canv.ctx.moveTo(x + w, y + h);
        canv.ctx.arcTo(
            x + w - horizontalLineW,
            y + h,
            x + w - horizontalLineW,
            y + horizontalLineH,
            r,
        );
        canv.ctx.lineTo(x + w - horizontalLineW, y + h - horizontalLineH);
        canv.ctx.lineTo(x + w - w * 0.325, y + h / 2);
        canv.ctx.lineTo(x + w - horizontalLineW, y + horizontalLineH);
        canv.ctx.arcTo(x + w - horizontalLineW, y, x + w, y, r);
        canv.ctx.lineTo(x + w, y);
        canv.ctx.moveTo(x + w, y);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" stroke-linejoin="round" d="M23 2h-4.46v7.7L16.58 12l1.96 2.3V22H23M12.83 8.56H1m11.83 3.58H1m8.88 3.22H1"/>
            </svg>
        `;
    }
}
